module.exports = __webpack_public_path__ + "static/media/ovam_logo.f7f1de32.png";